module.exports = __webpack_public_path__ + "media/images/france (1)-888de642d9a82161642b556ccba9732c.svg";